module.exports = __webpack_public_path__ + "img/portal_of_the_abyss_small.29c831c2.png";